<script setup lang="ts">

</script>

<template>
	<DFieldGroup
		class="inline-flex h-7 shrink-0 items-center divide-x overflow-hidden rounded-lg border border-accented bg-muted"
	>
		<slot />
	</DFieldGroup>
</template>
